import sortBy from 'lodash/sortBy';

import {
  StudentSectionOverview,
  StudentSectionOrSubSectionOverview,
} from './student.constants';

export function getStudentSectionsAndSubSectionsOverview(
  sections: StudentSectionOverview[]
): StudentSectionOrSubSectionOverview[] {
  return sortBy(sections, 'sort').flatMap(s => {
    return [s, ...(sortBy(s.subSectionsOverview, 'sort') || [])];
  });
}
